import SerializingLink from './SerializingLink';
export default SerializingLink;
